<template>
  <v-navigation-drawer
    :model-value="drawer"
    width="300"
    class="d-flex flex-column h-100 bg-primary"
    @update:model-value="$emit('update:drawer', $event)"
    app
  >
    <div class="d-flex flex-column fill-height">
      <div class="d-flex justify-space-between px-3 align-center">
        <router-link to="/" class="mt-3 mx-5">
          <img contain height="40" src="/images/logo_main1.png" />
        </router-link>
      </div>
      <v-list density="compact" class="flex-grow-1 overflow-y-auto my-3" nav>
        <template v-for="item in menuItems" :key="item.label">
          <v-list-group
            v-if="item.children"
            v-model="openGroup"
            :value="item.label"
            expand-icon="mdi-menu-down"
            collapse-icon="mdi-menu-up"
          >
            <template #activator="{ props }">
              <v-list-item
                v-bind="props"
                :prepend-icon="item.icon"
                :title="item.label"
              />
            </template>

            <v-list-item
              v-for="child in item.children"
              :key="child.label"
              :title="child.label"
              :prepend-icon="child.icon"
              :active="isActive(child.route)"
              @click="navigate(child.route)"
            />
          </v-list-group>

          <v-list-item
            v-else
            :prepend-icon="item.icon"
            :title="item.label"
            :active="isActive(item.route)"
            @click="navigate(item.route)"
          />
        </template>
      </v-list>
    </div>
  </v-navigation-drawer>
</template>

<script>
import { mapActions } from "pinia";
import { useLoginStore } from "@/store";
import { MENUS, USER_ROLES } from "@/shared/resource/constants";

export default {
  name: "SidebarUI",

  props: {
    rail: {
      type: Boolean,
      default: false,
    },
    drawer: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      openGroup: null,
    };
  },

  computed: {
    menuItems() {
      if (!this.$auth) return [];
      return this.$auth.role === USER_ROLES.SUPERADMIN
        ? MENUS.superAdmin
        : MENUS.admin;
    },
  },

  mounted() {
    const active = this.menuItems.find((i) =>i.children?.some((c) => c.route === this.$route.path));
    if (active) this.openGroup = active.label;
  },

  methods: {
    ...mapActions(useLoginStore, ["logout"]),

    hanldeLogout() {
      this.logout();
      this.$router.push("/login");
    },

    navigate(route) {
      if (route && this.$route.path !== route) {
        this.$router.push(route);
      }
    },

    isActive(route) {
      return this.$route.path === route;
    },

    getActiveItem() {
      for (const item of this.menuItems) {
        if (item.route === this.$route.path) return item;
        if (item.children) {
          const child = item.children.find((c) => c.route === this.$route.path);
          if (child) return child;
        }
      }
      return null;
    },
  },
};
</script>

<style scoped>
.v-list-item--density-compact.v-list-item--one-line {
  min-height: 36px !important;
}
</style>